/* src/app/shared/components/filter/filter.component.scss */
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Regular.ttf") format("truetype");
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-RegularItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Bold.ttf") format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-BoldItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: bold;
}
.container-box {
  background: #fff;
}
.filter-container {
  position: relative;
  padding: 0;
  min-height: 10.5rem;
}
.box-container {
  overflow: hidden;
  position: relative;
  margin-right: 0.5rem;
  padding: 0;
  min-height: 10.5rem;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #FFF;
}
.box-container .box-header {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 1rem;
  color: var(--secondary);
}
.box-container .box-header.h6 {
  font-size: 1rem;
  margin-top: 1.2rem;
}
.box-container .box-body {
  padding: 0.1rem 0.8rem;
}
.collapse-filters {
  position: absolute;
  z-index: 100;
  width: 100.5%;
  margin-left: -1.3rem;
  padding-left: 1.6rem;
  background: #fff;
  border-left: 5px solid rgb(109, 110, 106);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
}
::ng-deep .ant-select {
  margin-top: 0;
}
::ng-deep .nz-checkbox-wrapper label {
  top: 0.2rem !important;
}
.filter {
  position: relative;
  margin-top: 0.4rem;
}
.filter-input {
  width: 100%;
}
.filter-input,
.filter-label {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 500;
}
.filter-label {
  top: -0.85rem;
}
::ng-deep .ant-select .ant-select-selector {
  width: 100% !important;
  height: 32px !important;
  align-items: center;
}
::ng-deep .ant-checkbox-group,
::ng-deep .ant-checkbox-group {
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0em;
}
.multi-grouped {
  position: relative;
}
.multi-grouped .nz-label {
  left: 1.5rem;
}
.multi-grouped ::ng-deep .ant-checkbox-group {
  top: -0.2em;
}
.render-grouped {
  margin-right: 0.75rem;
}
.nz-label {
  width: 90%;
  display: inline-block;
  position: relative;
}
::ng-deep .ant-select-item-option-state {
  -webkit-user-select: none;
  user-select: none;
  position: absolute;
  right: 0.8rem;
  z-index: 99;
}
.dropdown-label {
  display: inline-block;
  width: 100%;
  padding-left: 0.5rem;
  z-index: 1000;
  position: relative;
  text-wrap: pretty;
}
.checkbox-input {
  appearance: none;
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid #CCC;
  border-radius: 4px;
  background-color: #fff;
  position: relative;
  cursor: pointer;
}
.checkbox-input:checked {
  border: 1px solid var(--primary);
}
.checkbox-input:checked::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 3px;
  width: 8px;
  height: 13px;
  border: solid var(--primary);
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.option {
  display: flex;
  padding-left: 0.5rem;
  align-items: center;
}
::ng-deep .ant-select-item-option-content {
  padding-left: 0.6rem;
}
::ng-deep .ant-select-item .anticon {
  color: var(--primary);
}
::ng-deep .filter-dropdown {
  max-width: 90vw;
}
::ng-deep .filter-dropdown .cdk-virtual-scroll-viewport {
  contain: none;
}
::ng-deep .filter-dropdown .ant-select-item-option-content,
::ng-deep .filter-dropdown .ant-select-item-group {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}
::ng-deep .filter-dropdown .nz-label {
  width: auto;
}
/*# sourceMappingURL=filter.component.css.map */
